const IS_STT_RTS = (status: string): boolean => !!status.match(/RTS/gi);
export default IS_STT_RTS;
